export enum StatusWniosku {
  Robocze = 1,
  Wyslano,
  DoSkompletowania,
  Dostarczono,
  CofnietoDoEdycji,
  Zarejestrowano,
  CofnietoDoUzupelnienia,
  WyslanoUzupelnione,
  PostanowionoBezRozpoznania,
  Wycofano,
  Odrzucono,
}
